module.exports = __webpack_public_path__ + "img/list.fd6bf37b.svg";